import { PhotoIcon } from "@heroicons/react/24/outline";
import { useRichTextEditorContext } from "@mantine/tiptap";

export const InsertImage: React.FC = () => {
    const { editor } = useRichTextEditorContext();

    if (!editor) {
        return null;
    }

    const handleInsertImage = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/jpeg,image/png";

        input.onchange = async (e) => {
            const file = (e.target as HTMLInputElement).files?.[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                const base64String = e.target?.result as string;
                editor
                    .chain()
                    .focus()
                    .setResizableImage({
                        src: base64String,
                        width: 200,
                        height: 200,
                        "data-keep-ratio": true,
                    })
                    .run();
            };
            reader.readAsDataURL(file);
        };

        input.click();
    };

    return (
        <button
            onClick={handleInsertImage}
            className="flex items-center gap-2 px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
            title="Insert image"
        >
            <PhotoIcon className="size-4" />
        </button>
    );
};
